// extracted by mini-css-extract-plugin
export default {"label":"Dropdown_label__bSwJS"};